import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";


const allCampaignSlice = createSlice({
  name: "allCampaignSetter",
  initialState: {
    campaignTab: localStorage.getItem("role")=='publisher'? 'WEBPAGE_CAMPAIGN_TAB' : "EMAIL_CAMPAIGN_TAB",
    campaignStatus: "",
    campaignSearch: "",
    campaignTabInfo: null,
    pageSize: 10,
    pageIndex: 0,
  },
  reducers: {
    setCampaignTab: (state, action) => {
      state.campaignTab = action.payload;
    },
    setCampaignStatus: (state, action) => {
      state.campaignStatus = action.payload;
    },
    setCampaignSearch: (state, action) => {
      state.campaignSearch = action.payload;
    },
    setCampaignTabInfo: (state, action) => {
      state.campaignTabInfo = action.payload;
    },
    persistPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    persistPageIndex: (state, action) => {
      state.pageIndex = action.payload;
    },
    resetCampaignStatus: (state, action) => {
      state.campaignStatus = "";
    },
    resetCampaignSearch: (state, action) => {
      state.campaignSearch = "";
    },
    resetAllCampaignData: (state, action) => {
      state.campaignTab = "EMAIL_CAMPAIGN_TAB";
      state.campaignStatus = "";
      state.campaignSearch = "";
      state.campaignTabInfo = null;
      state.pageSize = 10;
      state.pageIndex = 0;
    }
  },

});

export const {
  setCampaignTab,
  setCampaignStatus,
  setCampaignSearch,
  setCampaignTabInfo,
  persistPageSize,
  persistPageIndex,
  resetCampaignStatus,
  resetCampaignSearch,
  resetAllCampaignData
} = allCampaignSlice.actions;

export default allCampaignSlice.reducer;
